import React from "react";
import { ServiceEventNames, ServiceActionTypes } from '../../shared/utils/ServicesConstants';
import DraftBtn from "../../../../components/servicesButtons/DraftBtn";
import SubmitServiceBtn from "../../../../components/servicesButtons/SubmitServiceBtn";
import RejectBtn from "../../../../components/servicesButtons/RejectBtn";
import ApproveAndPayBtn from "../../../../components/servicesButtons/ApproveAndPayBtn";
import ApproveAndPayLaterBtn from "../../../../components/servicesButtons/ApproveAndPayLaterBtn";
import ApproveBtn from "../../../../components/servicesButtons/ApproveBtn";
import { eFormButtonsContainer } from "../../../../common/cssclasses";

const HorseLeasingActionButtons = ({
    id,
    action,
    eventName,
    isLessee,
    hasFees = true,
    canParticipateWithoutPayment,
    isPaymentComplete,
    selectedOwnerId,
    handleCreateEdit,
    handleRejectClick,
    handleApproveReject
}) => {
    const showDraftBtn = action !== ServiceActionTypes.VIEW && (!id || eventName === ServiceEventNames.DRAFT);
    const showSubmitBtn = action !== ServiceActionTypes.VIEW && (!id || eventName === ServiceEventNames.DRAFT || eventName === ServiceEventNames.SENT_BACK || eventName === ServiceEventNames.LESSEE_REJECTED);
    const showApproveRejectBtns = isLessee && action === ServiceActionTypes.APPROVE;

    return (
        <div className={eFormButtonsContainer}>
            {showDraftBtn && (
                <DraftBtn onClick={() => handleCreateEdit(ServiceEventNames.DRAFT)} />
            )}
            
            {(showSubmitBtn && !isLessee) && (
                <SubmitServiceBtn onClick={() => handleCreateEdit(ServiceActionTypes.SUBMIT)} />
            )}

            {showApproveRejectBtns && (
                <>
                    <RejectBtn onClick={handleRejectClick} />
                    {(!hasFees || isPaymentComplete) ? (
                        <ApproveBtn onClick={() => handleApproveReject(true, false)} />
                    ) : (
                        <>
                            {canParticipateWithoutPayment && (
                                <ApproveAndPayLaterBtn selectedAccountId={selectedOwnerId} onClick={() => handleApproveReject(true, false)} />
                            )}
                            <ApproveAndPayBtn onClick={() => handleApproveReject(true, true)} />
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default HorseLeasingActionButtons;
